import { $ } from '@/libs/jquery/index'
import 'select2/dist/js/select2.full'

export const baseSelector = '.select-custom-js'

export class Select2 {
  public static reinit(): void {
    $(baseSelector).select2({
      minimumResultsForSearch: Infinity,
      placeholder: 'Не выбрано',
    })
  }

  private selectors: ISelectors = {
    base: baseSelector,
  }

  constructor() {
    $(() => {
      if (this.selectors.base.length) {
        this.init()
      }
    })
  }

  public init(): void {
    Select2.reinit()
  }
}
